import { observer } from 'mobx-react-lite'
import { EmptyCell } from 'shared/ui/TableNew'
import { numberFormat } from 'shared/lib'

export const AnalyticMetricCell = observer(({ value }: { value: number | undefined | null }) => {
  if (!value) return <EmptyCell />
  return <>{numberFormat({ value })}</>
})
